import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://civilfox.app';

export default function PageMeta({
  title,
  description,
  path,
  type = 'website',
  image,
  robots = 'index, follow',
  structuredData,
}) {
  const canonical = path ? new URL(path, SITE_URL).href : undefined;
  const jsonLd = structuredData
    ? JSON.stringify(structuredData).replace(/</g, '\\u003c')
    : null;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robots} />
      {canonical && <link rel="canonical" href={canonical} />}
      <meta property="og:site_name" content="CivilFox" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {canonical && <meta property="og:url" content={canonical} />}
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}
      {jsonLd && <script type="application/ld+json">{jsonLd}</script>}
    </Helmet>
  );
}
